export default "__VITE_ASSET__673147a7__"